export class Employee {
    id: string;
    name: string;
    branch_id:string;
    user_id:string;
    org_id:string;
    gender: string;
    date_of_birth: string;
    nat_id: string;
    id_type: string;
    id_number:string;
    address:string;
    end_date:string;
    email:string;
    mobile:string;
    job_id: string;
    basic_salary: string;
    allowance: string;
    contract_start_date: string;
    contract_end_date: string;
  type_country: string;
    emp_status: string;
    row_id:string;


    bank_account_num: string;
    academic_qualification: string;
    emp_pic: string;

    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/employees/employees.ts